import { makeStyles } from "@material-ui/core/styles";
import { Backdrop, Box, CircularProgress, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import {
  originLocationSelected,
  changeOriginAddress,
  changeDestinationAddress,
  destinationLocationSelected,
  paths,
  resetState,
} from "../../../actions/actionCreators";
import {
  RESET_DESTINATION,
  UPDATE_DESTINATION_LATLNG,
  UPDATE_ORIGIN_LATLNG,
} from "../../../actions/actionsTypes";
import { push } from "connected-react-router";
import ButtonWithLoading from "../ButtonWithLoading";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "../../../i18nextInitiator";
import { useEffect, useRef, useState } from "react";
import { store } from "../../../store";
import { Close, Place } from "@material-ui/icons";
import { compose } from "redux";
import referralWrapper from "../Authentication/Referral/ReferralWrapper";
import Button from "@material-ui/core/Button";
import origin from "./origin.svg";
import { ReactComponent as FindCurrent } from "./current1.svg";
import { ReactComponent as Back } from "./back.svg";
import { ReactComponent as Back1 } from "./back1.svg";
import useGeoLocation from "../hooks/useGeoLocation";
import { getRoutes, getSearchResults } from "./apis";
import Marketing from "../Marketing";
import { NeshanMap } from "../Neshan";
import { getHeavyItemsByCity } from "../../../actions/apiCallActions";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "calc(100vh - 64px)",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
  },
  centeredMarker: {
    width: "45px",
    // height: "45px",
    position: "absolute",
    zIndex: 1000,
    top: "50vh",
    left: "50vw",
    // transform: "translate(-50%, -100%)",
    cursor: "pointer",
    transform: "translate(-50%, calc(-50% + 2px))",
    // animation: "marker-fade-in .7s 1 ease",
    transition: "all .3s linear",
    display: "flex",
    flexDirection: "column",
    // height: "65px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  destinationMarker: {
    width: "45px",
    // height: "45px",
    position: "absolute",
    zIndex: 1000,
    top: "calc(50vh - 100px)",
    left: "50vw",
    // transform: "translate(-50%, -100%)",
    cursor: "pointer",
    transform: "translate(-50%, calc(-50% + 20px))",
    animation: "marker-fade-in .7s 1 ease",
    transition: "all .3s linear",
    display: "flex",
    flexDirection: "column",
    // height: "65px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "@keyframes marker-fade-in": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  "@keyframes search-comes-up": {
    "0%": {
      transform: "translate(50%, 0)",
    },
    "100%": {
      transform: "translate(50%, 0)",
    },
  },
  searchContainer: {
    // position: "absolute",
    // left: 0,
    // right: 0,
    // height: "auto",
    // maxWidth: "380px",
    // display: "none",
    width: "100%",
    height: "100vh",
    zIndex: 100000000,
    paddingTop: "15px",
    position: "fixed",
    background: "#fff",
    transition: "all .5s ease",
    // transform: "translateX(50%)",
    // right: "50%",
    // top: 0,
    // bottom: 0,
  },
  searchBtn: {
    maxWidth: 380,
    fontSize: "1.3rem",
    height: 50,
    width: "90%",
    background: "#f7f7f7",
    marginBottom: "20px",
  },
  showSearch: {
    top: 0,
  },
  hideSearch: {
    top: "100%",
  },
  searchBox: {
    top: "10px",
    zIndex: 1200,
    marginRight: "auto",
    marginLeft: "auto",
    left: 0,
    right: 0,
    width: "90%",
    maxWidth: "380px",
    marginBottom: 25,
    display: "flex",
    flexDirection: "column-reverse",
    "& input": {
      height: 50,
      boxSizing: "border-box",
      backgroundColor: "#f1f1f1",
      borderRadius: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline , & .MuiOutlinedInput-notchedOutline:hover":
      {
        borderColor: "transparent !important",
      },
  },
  inputContainer: {
    backgroundColor: "white",
    borderRadius: "6px",
    maxWidth: "600px",
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: "0",
    },
  },
  searchButton: {
    position: "absolute",
    top: "50%",
    transform: " translateY(-50%)",
    right: 0,
    backgroundColor: "orange",
    height: "100%",
    width: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "0 6px 6px 0",
  },
  searchInput: {
    width: "100%",
    transition: "all 300ms ease-in-out",
  },
  resultContainer: {
    // position: "absolute",
    zIndex: 100000,
    bottom: "150px",
    borderRadius: "6px",
    backgroundColor: "white",
    marginRight: "auto",
    marginLeft: "auto",
    left: 0,
    right: 0,
    padding: "0 0 20px 0",
    maxWidth: "600px",
    overflow: "auto",
    maxHeight: "90vh",
    width: "90%",
    marginTop: "20px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#e6e6e6",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      borderRadius: "0.5rem",
    },
  },
  searchResult: {
    marginBottom: "16px",
    transition: "all 300ms ease-in-out",
    cursor: "pointer",
    padding: "5px",
    "&:hover": {
      padding: "10px",
      backgroundColor: "#e6e6e6",
      borderRadius: "6px",
    },
  },
  resultTitle: {
    marginBottom: "8px",
  },
  back: {
    maxWidth: "420px",
    margin: "0 auto",
    height: "150px",
    position: "fixed",
    zIndex: 1000000,
    right: 0,
    left: 0,
    top: 65,
  },
  backBtn: {
    height: 48,
    width: 48,
    boxShadow: "0 4px 4px rgba(0,0,0,0.25)",
    position: "absolute",
    top: "10px",
    left: "10px",
    zIndex: 1300,
    cursor: "pointer",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  findCurrent: {
    height: 48,
    width: 48,
    boxShadow: "0 4px 4px rgba(0,0,0,0.25)",
    position: "absolute",
    bottom: "180px",
    left: "10px",
    zIndex: 1300,
    cursor: "pointer",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
  },
  findCurrentDisabled: {
    height: 48,
    width: 48,
    boxShadow: "0 4px 4px rgba(0,0,0,0.25)",
    position: "absolute",
    bottom: "170px",
    left: "10px",
    zIndex: 1300,
    backgroundColor: "white",
    opacity: "0.8",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    cursor: "not-allowed",
    "&:after": {
      content: "''",
      height: "48px",
      width: "2px",
      backgroundColor: "red",
      transform: "rotate(-45deg)",
      position: "absolute",
      opacity: "0.8",
    },
  },
  backdrop: {
    color: "#fff",
    zIndex: 200000,
    backdropFilter: "blur(3px)",
  },
  box: (props) => ({
    background: "#fff",
    borderTopRightRadius: "20px",
    borderTopLeftRadius: "20px",
    boxShadow: "0 0 15px 0 rgba(0,0,0,.1)",
    maxWidth: "420px",
    margin: "0 auto",
    height: "160px",
    display: "flex",
    position: "fixed",
    zIndex: 1000000,
    right: 0,
    left: 0,
    bottom: 0,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    transition: "all .5s ease",
  }),
  dot: {
    width: "1px",
    height: "1px",
    marginTop: 5,
    // position: "absolute",
    // top: "50vh",
    // left: "50vw",
    // transform: "translate(-50%, calc(-50% + 2px))",
    // zIndex: 0,
    // transition: "all .3s linear",
  },
  moveDot: {
    width: "18px",
    height: "18px",
    marginTop: 5,
  },
}));

const t = i18n.getFixedT("fa", "location");

const Location = (props) => {
  const location = useLocation();
  let history = useHistory();
  const { coordinates, loaded, error } = useGeoLocation();

  const [text, setText] = useState("");
  const [move, setMove] = useState(false);
  const [showSearchBox, setBhowSearchBox] = useState(false);
  const [results, setResults] = useState(null);
  const classes = useStyles({ showSearchBox });
  const mapRef = useRef(null);
  const leaflet = useRef(null);
  const markerRef = useRef(null);
  const polyRef = useRef(null);

  const { startAddressLat: lat, startAddressLong: long } =
    store.getState().order.order;

  const {
    firstPage,
    order: { startAddressLat, startAddressLong },
  } = props;

  const [mapCenter, setMapCenter] = useState([35.700944, 51.391151]);

  const [route, setRoute] = useState([]);

  const markerPosition = [props?.map?.marker.lat, props?.map?.marker.lng];

  const destSelected = (data) => {
    props.destinationLocationSelected(data);
  };

  const findCurrentLocation = (e) => {
    if (loaded && !error) {
      mapRef.current.panTo(coordinates);
    }
  };

  const updateLocation = (latlng) => {
    setMapCenter([latlng.lat, latlng.lng]);
    store.dispatch({
      type: window.location.pathname.includes(paths.selectDestination)
        ? UPDATE_DESTINATION_LATLNG
        : UPDATE_ORIGIN_LATLNG,
      latlng,
    });

    if (!window.location.pathname.includes(paths.selectDestination)) {
      localStorage.setItem("originLat", mapRef.current.getCenter().lat);
      localStorage.setItem("originLng", mapRef.current.getCenter().lng);
    }

    if (window.location.pathname.includes(paths.selectDestination)) {
      getRoutes({
        setRoute,
        destLat: mapRef.current.getCenter().lat,
        destLng: mapRef.current.getCenter().lng,
        originLat: localStorage.getItem("originLat"),
        originLng: localStorage.getItem("originLng"),
      });
    }
  };

  const onConfirmLocation = () => {
    if (window.location.pathname.includes(paths.selectDestination)) {
      destSelected(mapRef.current.getCenter());
      getHeavyItemsByCity({ lat, long });
    } else {
      mapRef.current.setZoom(16);
      originLocationSelected(mapRef.current.getCenter());
    }
  };
  const showSearch = () => {
    setBhowSearchBox(true);
  };
  const onBack = () => {
    history.goBack();
    mapRef.current.setZoom(18);
  };

  const onLocationClick = (latlng) => {
    setMapCenter([latlng.lat, latlng.lng]);
    mapRef.current.panTo(latlng);
    updateLocation(latlng);
    clearSearch();
  };

  function clearSearch() {
    setResults(null);
    setText("");
    setBhowSearchBox(false);
  }

  useEffect(() => {
    if (text.length > 1) {
      getSearchResults({
        setResults,
        lat: mapCenter[0],
        lng: mapCenter[1],
        text,
      });
    }
  }, [text]);

  useEffect(() => {
    if (
      window.location.pathname.includes(paths.selectDestination) &&
      !startAddressLat
    )
      firstPage();
    if (!window.location.pathname.includes(paths.selectDestination))
      resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    props.resetLocations();
  }, [location]);

  useEffect(() => {
    if (
      window.location.pathname.includes(paths.selectDestination) &&
      leaflet.current &&
      mapRef.current
    ) {
      markerRef.current = leaflet.current
        .marker(markerPosition, {
          icon: leaflet.current.icon({
            iconUrl: origin.toString(),
            iconSize: [60, 140],
            iconAnchor: [30, 70],
          }),
        })
        .addTo(mapRef.current);
    }
    if (
      markerRef.current &&
      !window.location.pathname.includes(paths.selectDestination)
    ) {
      mapRef.current.removeLayer(markerRef.current);
    }
  }, [location]);

  // useEffect(() => {
  //   if (
  //     route &&
  //     window.location.pathname.includes(paths.selectDestination) &&
  //     leaflet.current &&
  //     mapRef.current
  //   ) {
  //     if (polyRef.current) {
  //       mapRef.current.removeLayer(polyRef.current);
  //     }
  //     polyRef.current = leaflet.current
  //       .polyline([route], {
  //         fillOpacity: 0.5,
  //         radius: 500,
  //       })
  //       .addTo(mapRef.current);
  //   }
  // }, [route, location]);

  return (
    <Box className={classes.root}>
      <Marketing />
      <NeshanMap
        onInit={(L, myMap) => {
          myMap.setMapType("neshan");
          mapRef.current = myMap;
          leaflet.current = L;
          myMap.on("click", function (e) {
            myMap.panTo(e.latlng);
            updateLocation(e.latlng);
          });
          myMap.on("movestart", function () {
            console.log(111);
            setMove(true);
          });
          myMap.on("moveend", function () {
            updateLocation(myMap.getCenter());
            setMove(false);
          });
        }}
        options={{
          key: "web.s84rqwe3QiNdbVy9XlnkJSAjxTVLjbr4RCSAl6Fa",
          center: mapCenter,
          zoom: 18,
          minZoom: 4,
          maxZoom: 19,
        }}
        style={{
          height: "92vh",
          width: "100%",
        }}
      />
      <Box
        onClick={onConfirmLocation}
        className={
          window.location.pathname === paths.selectDestination
            ? classes.destinationMarker
            : classes.centeredMarker
        }
        style={{ pointerEvents: "none" }}
      >
        <img
          height="100%"
          width="100%"
          src={
            window.location.pathname === paths.selectDestination
              ? "/orders/images/icons/destination-pin.svg"
              : "/orders/images/icons/origin-pin.svg"
          }
          alt="pin"
        />
        <img
          height="100%"
          width="100%"
          src={"/orders/images/icons/dot.svg"}
          alt=""
          className={move ? classes.moveDot : classes.dot}
        />
      </Box>

      <Backdrop className={classes.backdrop} open={props.isSelectingLocation}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {window.location.pathname.includes(paths.selectDestination) && (
        <Box className={classes.back}>
          <Box onClick={onBack} className={classes.backBtn}>
            <Back style={{ transform: "scale(1.2)" }} />
          </Box>
        </Box>
      )}
      <Box
        className={`${classes.searchContainer} ${
          showSearchBox ? classes.showSearch : classes.hideSearch
        }`}
      >
        <Back1
          style={{
            transform: "scale(1.2)",
            marginRight: "6%",
            marginBottom: "10px",
            cursor: "pointer",
          }}
          onClick={() => {
            setBhowSearchBox(false);
            clearSearch();
          }}
        />
        <Box className={classes.searchBox}>
          {results && (
            <Box className={classes.resultContainer}>
              {results.count === 0 ? (
                <p>نتیجه ای یافت نشد</p>
              ) : (
                results.items.map(({ address, location, title }) => {
                  return (
                    <Box
                      onClick={() =>
                        onLocationClick({ lat: location.y, lng: location.x })
                      }
                      className={classes.searchResult}
                    >
                      <Box className={classes.resultTitle}>
                        <Place />
                        {title}
                      </Box>
                      <Box className={classes.resultTitle}>{address}</Box>
                    </Box>
                  );
                })
              )}
            </Box>
          )}
          <Box className={classes.inputContainer}>
            {/* {text.length > 0 && (
                <div onClick={() => clearSearch()}>
                  <span> &#10006; </span>
                </div>
              )} */}
            <TextField
              className={classes.searchInput}
              id="outlined-basic"
              label="جستجو"
              value={text}
              variant="outlined"
              InputProps={{
                endAdornment:
                  text.length > 0 ? (
                    <Close
                      onClick={clearSearch}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  ) : null,
              }}
              onChange={(e) => {
                if (e.target.value.length === 0) clearSearch();
                setText(e.target.value);
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box
        className={`${classes.box} ${showSearchBox ? classes.hideSearch : ""}`}
      >
        <Box
          onClick={!error ? (e) => findCurrentLocation(e) : null}
          className={`${
            error ? classes.findCurrentDisabled : classes.findCurrent
          }`}
        >
          <FindCurrent style={{ transform: "scale(1.2)" }} />
        </Box>

        <Button onClick={showSearch} className={`${classes.searchBtn} `}>
          جستجو
        </Button>
        <ButtonWithLoading
          style={{
            maxWidth: 380,
            fontSize: "1.3rem",
            height: 50,
            zIndex: 1000,
            bottom: "10px",
            width: "90%",
          }}
          text={
            !window.location.pathname.includes(paths.selectDestination)
              ? t("select-origin")
              : t("select-dest")
          }
          action={onConfirmLocation}
          disabled={props.isSelectingLocation}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({ ...state.order });
const mapDispatchToProps = (dispatch) => ({
  originLocationSelected,
  changeOriginAddress,
  changeDestinationAddress,
  destinationLocationSelected,
  firstPage: () => dispatch(push("/")),
  resetLocations: () => dispatch({ type: RESET_DESTINATION }),
});

export default compose(
  referralWrapper,
  connect(mapStateToProps, mapDispatchToProps)
)(Location);
